import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { handleDropdownMenuContainerKeydown } from 'app/shared/utils/dropdown-menu-keyboard.util';

@Component({
  selector: 'kh-dropdown-menu',
  templateUrl: './dropdown-menu.component.html',
  styleUrls: ['./dropdown-menu.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DropdownMenuComponent {
  private static nextId = 0;

  private readonly dropdownId = DropdownMenuComponent.nextId++;

  public readonly buttonId = `dropdown-menu-button-${this.dropdownId}`;
  public readonly menuId = `dropdown-menu-list-${this.dropdownId}`;

  @Input() public label?: string;
  @Input() public ariaLabel?: string;
  @Input() public alignmentRight = false;
  public isOpen = false;

  public onToggleKeydown(event: KeyboardEvent, dropdown: { toggle(value?: boolean): void }): void {
    event.preventDefault();
    dropdown.toggle(!this.isOpen);
  }

  public onMenuKeydown(event: KeyboardEvent, dropdown: { hide(): void }): void {
    handleDropdownMenuContainerKeydown(event, () => dropdown.hide());
  }
}
